export default __webpack_public_path__ + "static/media/handlCare.f089f3b5.svg";